import styles from './ExpandableOrderSummary.module.css';
import ExpandySection from 'components/ExpandySection';
import ShoppingCart from '../svg/ShoppingCart.svg';
import ChevronLeft15 from '../svg/ChevronLeft15.svg';
import OrderSummaryRows, {
  Props as OrderSummaryRowsProps,
} from './OrderSummaryRows';
import OrderSummaryCosts from './OrderSummaryCosts';
import { observer } from 'mobx-react-lite';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { formattedPriceStringFromPence } from 'utils/common';

interface Props extends OrderSummaryRowsProps {}

const ExpandableOrderSummary = observer((props: Props) => {
  const { orderCost } = useEnterStore();
  const isDiscounted = orderCost.price !== orderCost.cost;

  return (
    <ExpandySection
      containerClassName={styles.container}
      expandedContainerClassName={styles.containerExpanded}
      headerContent={
        <div className={styles.header}>
          <ShoppingCart className={styles.cart} />
          <span className={styles.totalText}>Total</span>
          <span className={styles.headerCosts + ' aboutUsTypographyBodySmall'}>
            {isDiscounted ? (
              <>
                {formattedPriceStringFromPence(orderCost.cost)} this week{' '}
                <span
                  className={styles.ongoingCosts + ' aboutUsTypographyCaption'}
                >
                  then {formattedPriceStringFromPence(orderCost.price)} per week
                </span>
              </>
            ) : (
              <>{formattedPriceStringFromPence(orderCost.price)} per week</>
            )}
          </span>
          <ChevronLeft15 className={styles.chevron} />
        </div>
      }
    >
      <div className={styles.content}>
        <hr />
        <div>
          <OrderSummaryRows {...props} />
        </div>
        <hr />
        <OrderSummaryCosts />
        <hr />
        <strong className={styles.cancelText}>👋 Cancel anytime 👋</strong>
      </div>
    </ExpandySection>
  );
});

export default ExpandableOrderSummary;
